import { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DictionaryActions from './DictionaryActions';
import SynonymSetModal from './modals/SynonymSetModal';
import SearchBar from './SearchBar';

const StyledAddButton = styled(Button)(({ theme, isSmallScreen }) => ({
  flex: 1,
  height: '50%',
  marginLeft: isSmallScreen ? 0 : theme.spacing(1),
  marginRight: theme.spacing(1),
}));

const SynonymActionGroup = ({
  dictionary,
  handleCreateSynonymSet,
  isSearching,
  searchConfig,
  updateSearchConfig,
  numberFound,
  ...dictionaryActions
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const openCreateModal = () => setCreateModalOpen(true);
  const closeCreateModal = () => setCreateModalOpen(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isSmallScreen ? 'column-reverse' : 'row',
        mb: 2,
      }}
    >
      <SearchBar
        isSearching={isSearching}
        numberFound={numberFound}
        searchConfig={searchConfig}
        updateSearchConfig={updateSearchConfig}
      />

      <Box sx={{ display: 'flex', my: isSmallScreen ? 2 : 0 }}>
        <StyledAddButton
          startIcon={<AddIcon />}
          size="small"
          isSmallScreen={isSmallScreen}
          onClick={openCreateModal}
          aria-label="add synonym set"
        >
          {t('add', {
            ns: 'buttons',
            text: t('synonym.set', { ns: 'project' }),
          })}
        </StyledAddButton>

        <DictionaryActions dictionary={dictionary} {...dictionaryActions} />
      </Box>

      <SynonymSetModal
        open={createModalOpen}
        handleClose={closeCreateModal}
        handleCreate={handleCreateSynonymSet}
      />
    </Box>
  );
};

SynonymActionGroup.propTypes = {
  dictionary: PropTypes.object,
  handleCreateSynonymSet: PropTypes.func.isRequired,
  isSearching: PropTypes.bool,
  searchConfig: PropTypes.object,
  updateSearchConfig: PropTypes.func,
  numberFound: PropTypes.number,
};

export default SynonymActionGroup;
